/** Stati operativi ospite in lista fascicoli assistenziali. */

export const STATO_ATTIVO = "ATTIVO";
export const STATO_PRE_INGRESSO = "PRE_INGRESSO";
export const STATO_DIMISSIONE_PROGRAMMATA = "DIMISSIONE_PROGRAMMATA";
export const STATO_DIMESSO = "DIMESSO";

export const OSPITE_STATO_FILTERS = [
  { value: "tutti", label: "Tutti" },
  { value: STATO_ATTIVO, label: "Attivi" },
  { value: STATO_PRE_INGRESSO, label: "Pre-Ingressi" },
  { value: STATO_DIMISSIONE_PROGRAMMATA, label: "Dimissioni Programmate" },
  { value: STATO_DIMESSO, label: "Dimessi" },
];

function startOfDay(d) {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function parseIsoDate(s) {
  if (!s || !String(s).trim()) return null;
  const d = new Date(String(s).trim().slice(0, 10));
  return Number.isNaN(d.getTime()) ? null : startOfDay(d);
}

/** Risolve stato da API o da date (fallback client). */
export function resolveStatoOspite(c) {
  const stored = (c?.stato_ospite || "").trim();
  const today = startOfDay(new Date());
  const uscita = parseIsoDate(c?.data_uscita);
  if (uscita) {
    if (uscita.getTime() <= today.getTime()) return STATO_DIMESSO;
    return STATO_DIMISSIONE_PROGRAMMATA;
  }
  const ingresso = parseIsoDate(c?.data_ingresso_prevista || c?.data_ingresso);
  if (ingresso && ingresso.getTime() > today.getTime()) return STATO_PRE_INGRESSO;
  if (
    stored === STATO_PRE_INGRESSO ||
    stored === STATO_DIMISSIONE_PROGRAMMATA ||
    stored === STATO_DIMESSO
  ) {
    return stored;
  }
  return STATO_ATTIVO;
}

export function formatDataItShort(s) {
  if (!s || !String(s).trim()) return "—";
  const d = new Date(String(s).trim().slice(0, 10));
  return Number.isNaN(d.getTime()) ? String(s).trim() : d.toLocaleDateString("it-IT");
}

export function ospiteStatoLabel(stato) {
  switch (stato) {
    case STATO_PRE_INGRESSO:
      return "Pre-Ingresso";
    case STATO_DIMISSIONE_PROGRAMMATA:
      return "Dimissione Programmata";
    case STATO_DIMESSO:
      return "Dimesso";
    default:
      return "Attivo";
  }
}

export function ospiteStatoDot(stato) {
  switch (stato) {
    case STATO_PRE_INGRESSO:
      return "🟡";
    case STATO_DIMISSIONE_PROGRAMMATA:
      return "🟠";
    case STATO_DIMESSO:
      return "⚫";
    default:
      return "🟢";
  }
}

/** Bordo superiore, badge e desaturazione card. */
export function ospiteStatoVisuals(stato) {
  switch (stato) {
    case STATO_PRE_INGRESSO:
      return {
        topBorder: "border-t-[5px] border-t-amber-400",
        badge: "bg-amber-100 text-amber-900 ring-1 ring-amber-300 hover:bg-amber-100",
        dot: "bg-amber-500",
        stateBox: "bg-amber-50 border-amber-200 text-amber-950",
        cardMuted: "",
      };
    case STATO_DIMISSIONE_PROGRAMMATA:
      return {
        topBorder: "border-t-[5px] border-t-orange-500",
        badge: "bg-orange-100 text-orange-900 ring-1 ring-orange-300 hover:bg-orange-100",
        dot: "bg-orange-500",
        stateBox: "bg-orange-50 border-orange-200 text-orange-950",
        cardMuted: "",
      };
    case STATO_DIMESSO:
      return {
        topBorder: "border-t-[5px] border-t-slate-400",
        badge: "bg-slate-200 text-slate-700 ring-1 ring-slate-300 hover:bg-slate-200",
        dot: "bg-slate-500",
        stateBox: "bg-slate-100 border-slate-200 text-slate-700",
        cardMuted: "opacity-[0.88] saturate-[0.85]",
      };
    default:
      return {
        topBorder: "border-t-[5px] border-t-emerald-500",
        badge: "bg-emerald-100 text-emerald-800 ring-1 ring-emerald-300 hover:bg-emerald-100",
        dot: "bg-emerald-500",
        stateBox: "bg-emerald-50 border-emerald-200 text-emerald-900",
        cardMuted: "",
      };
  }
}

export function matchOspiteStatoSearch(term, stato) {
  const t = term.toLowerCase();
  if (!t) return true;
  const label = ospiteStatoLabel(stato).toLowerCase();
  return label.includes(t) || (stato || "").toLowerCase().includes(t);
}
